import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    HostListener,
    Input,
    OnChanges,
    QueryList
} from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { FadeSliderSlideComponent } from '@df/ui/fade-slider/fade-slider-slide.component';

export namespace NFadeSlider {
    export interface IOptions {
        /**
         * Change interval (in seconds)
         */
        interval?: number;
        /**
         * If caoursel should pouse on hover
         */
        pouseOnHover: boolean;
    }
}
/**
 *  <fade-slider>
 *      <div fadeSliderSlide *ngFor="let slide of slides">
 *          ...
 *      </div>
 *  </fade-slider>
 */
@Component({
    selector: 'fade-slider',
    templateUrl: './fade-slider.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FadeSliderComponent implements OnChanges, AfterViewInit {
    /**
     * List of slides
     */
    @ContentChildren(FadeSliderSlideComponent)
    fadeSliderSlides?: QueryList<FadeSliderSlideComponent>;

    /**
     * Carousel options
     */
    @Input()
    options?: NFadeSlider.IOptions;

    /**
     * Interval id
     */
    private interval?: number;

    /**
     * If is hovered
     */
    private isHover = false;

    /**
     * Task dependencies
     */
    constructor(
        private timeoutService: TimeoutService,
        private changeDetectoRef: ChangeDetectorRef
    ) {}

    ngOnChanges() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        if (this.options?.interval) {
            this.interval = this.timeoutService.setInterval(() => {
                if (!(this.isHover && this.options?.pouseOnHover)) {
                    this.next();
                }
            }, this.options.interval * 1000);
        }
    }

    ngAfterViewInit() {
        this.goTo(0);
    }

    private next() {
        const slides = this.fadeSliderSlides?.toArray() || [];
        const index = slides.findIndex(i => i.current);
        this.goTo(slides[index + 1] ? index + 1 : 0);
    }

    private goTo(index: number) {
        this.fadeSliderSlides?.forEach((slide, i) => (slide.current = i === index));
    }

    @HostListener('mouseenter')
    onMouseIn() {
        this.isHover = true;
    }

    @HostListener('mouseleave')
    onMouseOut() {
        this.isHover = false;
    }
}
